// source: proto/reportpb/reportbalance.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

var google_type_date_pb = require('../../google/type/date_pb.js');
goog.object.extend(proto, google_type_date_pb);
var proto_utilspb_pagination_pb = require('../../proto/utilspb/pagination_pb.js');
goog.object.extend(proto, proto_utilspb_pagination_pb);
goog.exportSymbol('proto.reportpb.AccountBalance', null, global);
goog.exportSymbol('proto.reportpb.BalanceSummaryReport', null, global);
goog.exportSymbol('proto.reportpb.ListBalanceSummary', null, global);
goog.exportSymbol('proto.reportpb.ListBalanceSummaryReportResponse', null, global);
goog.exportSymbol('proto.reportpb.ListReportBalanceRequest', null, global);
goog.exportSymbol('proto.reportpb.SubAccountBalance', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.SubAccountBalance = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.SubAccountBalance, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.SubAccountBalance.displayName = 'proto.reportpb.SubAccountBalance';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.AccountBalance = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.reportpb.AccountBalance.repeatedFields_, null);
};
goog.inherits(proto.reportpb.AccountBalance, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.AccountBalance.displayName = 'proto.reportpb.AccountBalance';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.BalanceSummaryReport = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.reportpb.BalanceSummaryReport.repeatedFields_, null);
};
goog.inherits(proto.reportpb.BalanceSummaryReport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.BalanceSummaryReport.displayName = 'proto.reportpb.BalanceSummaryReport';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListBalanceSummary = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ListBalanceSummary, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListBalanceSummary.displayName = 'proto.reportpb.ListBalanceSummary';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListReportBalanceRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.reportpb.ListReportBalanceRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListReportBalanceRequest.displayName = 'proto.reportpb.ListReportBalanceRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.reportpb.ListBalanceSummaryReportResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.reportpb.ListBalanceSummaryReportResponse.repeatedFields_, null);
};
goog.inherits(proto.reportpb.ListBalanceSummaryReportResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.reportpb.ListBalanceSummaryReportResponse.displayName = 'proto.reportpb.ListBalanceSummaryReportResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.SubAccountBalance.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.SubAccountBalance.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.SubAccountBalance} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.SubAccountBalance.toObject = function(includeInstance, msg) {
  var f, obj = {
    masterAccountNo: jspb.Message.getFieldWithDefault(msg, 1, ""),
    accountNo: jspb.Message.getFieldWithDefault(msg, 2, ""),
    subAccountNo: jspb.Message.getFieldWithDefault(msg, 3, ""),
    cashBalance: jspb.Message.getFieldWithDefault(msg, 4, ""),
    shortMarketValue: jspb.Message.getFieldWithDefault(msg, 5, ""),
    longMarketValue: jspb.Message.getFieldWithDefault(msg, 6, ""),
    equity: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.SubAccountBalance}
 */
proto.reportpb.SubAccountBalance.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.SubAccountBalance;
  return proto.reportpb.SubAccountBalance.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.SubAccountBalance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.SubAccountBalance}
 */
proto.reportpb.SubAccountBalance.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccountNo(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNo(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubAccountNo(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setCashBalance(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setShortMarketValue(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setLongMarketValue(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setEquity(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.SubAccountBalance.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.SubAccountBalance.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.SubAccountBalance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.SubAccountBalance.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSubAccountNo();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCashBalance();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getShortMarketValue();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getLongMarketValue();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getEquity();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional string master_account_no = 1;
 * @return {string}
 */
proto.reportpb.SubAccountBalance.prototype.getMasterAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.SubAccountBalance} returns this
 */
proto.reportpb.SubAccountBalance.prototype.setMasterAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_no = 2;
 * @return {string}
 */
proto.reportpb.SubAccountBalance.prototype.getAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.SubAccountBalance} returns this
 */
proto.reportpb.SubAccountBalance.prototype.setAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string sub_account_no = 3;
 * @return {string}
 */
proto.reportpb.SubAccountBalance.prototype.getSubAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.SubAccountBalance} returns this
 */
proto.reportpb.SubAccountBalance.prototype.setSubAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string cash_balance = 4;
 * @return {string}
 */
proto.reportpb.SubAccountBalance.prototype.getCashBalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.SubAccountBalance} returns this
 */
proto.reportpb.SubAccountBalance.prototype.setCashBalance = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string short_market_value = 5;
 * @return {string}
 */
proto.reportpb.SubAccountBalance.prototype.getShortMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.SubAccountBalance} returns this
 */
proto.reportpb.SubAccountBalance.prototype.setShortMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string long_market_value = 6;
 * @return {string}
 */
proto.reportpb.SubAccountBalance.prototype.getLongMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.SubAccountBalance} returns this
 */
proto.reportpb.SubAccountBalance.prototype.setLongMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string equity = 7;
 * @return {string}
 */
proto.reportpb.SubAccountBalance.prototype.getEquity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.SubAccountBalance} returns this
 */
proto.reportpb.SubAccountBalance.prototype.setEquity = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.reportpb.AccountBalance.repeatedFields_ = [9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.AccountBalance.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.AccountBalance.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.AccountBalance} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.AccountBalance.toObject = function(includeInstance, msg) {
  var f, obj = {
    masterAccountNo: jspb.Message.getFieldWithDefault(msg, 1, ""),
    correspondent: jspb.Message.getFieldWithDefault(msg, 2, ""),
    accountNo: jspb.Message.getFieldWithDefault(msg, 3, ""),
    accountName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    cashBalance: jspb.Message.getFieldWithDefault(msg, 5, ""),
    shortMarketValue: jspb.Message.getFieldWithDefault(msg, 6, ""),
    longMarketValue: jspb.Message.getFieldWithDefault(msg, 7, ""),
    equity: jspb.Message.getFieldWithDefault(msg, 8, ""),
    subAccountBalancesList: jspb.Message.toObjectList(msg.getSubAccountBalancesList(),
    proto.reportpb.SubAccountBalance.toObject, includeInstance),
    balanceSummaryReportIndex: jspb.Message.getFieldWithDefault(msg, 10, 0),
    accountBalanceIndex: jspb.Message.getFieldWithDefault(msg, 11, 0),
    rep: jspb.Message.getFieldWithDefault(msg, 12, ""),
    branch: jspb.Message.getFieldWithDefault(msg, 13, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.AccountBalance}
 */
proto.reportpb.AccountBalance.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.AccountBalance;
  return proto.reportpb.AccountBalance.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.AccountBalance} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.AccountBalance}
 */
proto.reportpb.AccountBalance.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccountNo(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrespondent(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNo(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCashBalance(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setShortMarketValue(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setLongMarketValue(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setEquity(value);
      break;
    case 9:
      var value = new proto.reportpb.SubAccountBalance;
      reader.readMessage(value,proto.reportpb.SubAccountBalance.deserializeBinaryFromReader);
      msg.addSubAccountBalances(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setBalanceSummaryReportIndex(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAccountBalanceIndex(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setRep(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setBranch(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.AccountBalance.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.AccountBalance.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.AccountBalance} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.AccountBalance.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAccountName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCashBalance();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getShortMarketValue();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLongMarketValue();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getEquity();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSubAccountBalancesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.reportpb.SubAccountBalance.serializeBinaryToWriter
    );
  }
  f = message.getBalanceSummaryReportIndex();
  if (f !== 0) {
    writer.writeUint32(
      10,
      f
    );
  }
  f = message.getAccountBalanceIndex();
  if (f !== 0) {
    writer.writeUint32(
      11,
      f
    );
  }
  f = message.getRep();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getBranch();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
};


/**
 * optional string master_account_no = 1;
 * @return {string}
 */
proto.reportpb.AccountBalance.prototype.getMasterAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.AccountBalance} returns this
 */
proto.reportpb.AccountBalance.prototype.setMasterAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string correspondent = 2;
 * @return {string}
 */
proto.reportpb.AccountBalance.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.AccountBalance} returns this
 */
proto.reportpb.AccountBalance.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string account_no = 3;
 * @return {string}
 */
proto.reportpb.AccountBalance.prototype.getAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.AccountBalance} returns this
 */
proto.reportpb.AccountBalance.prototype.setAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string account_name = 4;
 * @return {string}
 */
proto.reportpb.AccountBalance.prototype.getAccountName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.AccountBalance} returns this
 */
proto.reportpb.AccountBalance.prototype.setAccountName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string cash_balance = 5;
 * @return {string}
 */
proto.reportpb.AccountBalance.prototype.getCashBalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.AccountBalance} returns this
 */
proto.reportpb.AccountBalance.prototype.setCashBalance = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string short_market_value = 6;
 * @return {string}
 */
proto.reportpb.AccountBalance.prototype.getShortMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.AccountBalance} returns this
 */
proto.reportpb.AccountBalance.prototype.setShortMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string long_market_value = 7;
 * @return {string}
 */
proto.reportpb.AccountBalance.prototype.getLongMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.AccountBalance} returns this
 */
proto.reportpb.AccountBalance.prototype.setLongMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string equity = 8;
 * @return {string}
 */
proto.reportpb.AccountBalance.prototype.getEquity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.AccountBalance} returns this
 */
proto.reportpb.AccountBalance.prototype.setEquity = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * repeated SubAccountBalance sub_account_balances = 9;
 * @return {!Array<!proto.reportpb.SubAccountBalance>}
 */
proto.reportpb.AccountBalance.prototype.getSubAccountBalancesList = function() {
  return /** @type{!Array<!proto.reportpb.SubAccountBalance>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.reportpb.SubAccountBalance, 9));
};


/**
 * @param {!Array<!proto.reportpb.SubAccountBalance>} value
 * @return {!proto.reportpb.AccountBalance} returns this
*/
proto.reportpb.AccountBalance.prototype.setSubAccountBalancesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.reportpb.SubAccountBalance=} opt_value
 * @param {number=} opt_index
 * @return {!proto.reportpb.SubAccountBalance}
 */
proto.reportpb.AccountBalance.prototype.addSubAccountBalances = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.reportpb.SubAccountBalance, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.reportpb.AccountBalance} returns this
 */
proto.reportpb.AccountBalance.prototype.clearSubAccountBalancesList = function() {
  return this.setSubAccountBalancesList([]);
};


/**
 * optional uint32 balance_summary_report_index = 10;
 * @return {number}
 */
proto.reportpb.AccountBalance.prototype.getBalanceSummaryReportIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.AccountBalance} returns this
 */
proto.reportpb.AccountBalance.prototype.setBalanceSummaryReportIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional uint32 account_balance_index = 11;
 * @return {number}
 */
proto.reportpb.AccountBalance.prototype.getAccountBalanceIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.AccountBalance} returns this
 */
proto.reportpb.AccountBalance.prototype.setAccountBalanceIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional string rep = 12;
 * @return {string}
 */
proto.reportpb.AccountBalance.prototype.getRep = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.AccountBalance} returns this
 */
proto.reportpb.AccountBalance.prototype.setRep = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string branch = 13;
 * @return {string}
 */
proto.reportpb.AccountBalance.prototype.getBranch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.AccountBalance} returns this
 */
proto.reportpb.AccountBalance.prototype.setBranch = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.reportpb.BalanceSummaryReport.repeatedFields_ = [7];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.BalanceSummaryReport.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.BalanceSummaryReport.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.BalanceSummaryReport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.BalanceSummaryReport.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    correspondent: jspb.Message.getFieldWithDefault(msg, 2, ""),
    accountNo: jspb.Message.getFieldWithDefault(msg, 3, ""),
    subAccountNo: jspb.Message.getFieldWithDefault(msg, 4, ""),
    accountName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    masterAccountNo: jspb.Message.getFieldWithDefault(msg, 6, ""),
    accountBalancesList: jspb.Message.toObjectList(msg.getAccountBalancesList(),
    proto.reportpb.AccountBalance.toObject, includeInstance),
    broker: jspb.Message.getFieldWithDefault(msg, 8, ""),
    type: jspb.Message.getFieldWithDefault(msg, 9, ""),
    dateType: jspb.Message.getFieldWithDefault(msg, 10, ""),
    date: (f = msg.getDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    cashBalance: jspb.Message.getFieldWithDefault(msg, 12, ""),
    shortMarketValue: jspb.Message.getFieldWithDefault(msg, 13, ""),
    longMarketValue: jspb.Message.getFieldWithDefault(msg, 14, ""),
    equity: jspb.Message.getFieldWithDefault(msg, 15, ""),
    adjustedBalance: jspb.Message.getFieldWithDefault(msg, 16, ""),
    balanceSummaryReportIndex: jspb.Message.getFieldWithDefault(msg, 17, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.BalanceSummaryReport}
 */
proto.reportpb.BalanceSummaryReport.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.BalanceSummaryReport;
  return proto.reportpb.BalanceSummaryReport.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.BalanceSummaryReport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.BalanceSummaryReport}
 */
proto.reportpb.BalanceSummaryReport.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrespondent(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNo(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubAccountNo(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccountNo(value);
      break;
    case 7:
      var value = new proto.reportpb.AccountBalance;
      reader.readMessage(value,proto.reportpb.AccountBalance.deserializeBinaryFromReader);
      msg.addAccountBalances(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setBroker(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateType(value);
      break;
    case 11:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setCashBalance(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setShortMarketValue(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setLongMarketValue(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setEquity(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdjustedBalance(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setBalanceSummaryReportIndex(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.BalanceSummaryReport.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.BalanceSummaryReport.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.BalanceSummaryReport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.BalanceSummaryReport.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSubAccountNo();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getAccountName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAccountBalancesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.reportpb.AccountBalance.serializeBinaryToWriter
    );
  }
  f = message.getBroker();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getDateType();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      11,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getCashBalance();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getShortMarketValue();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getLongMarketValue();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getEquity();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getAdjustedBalance();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getBalanceSummaryReportIndex();
  if (f !== 0) {
    writer.writeUint32(
      17,
      f
    );
  }
};


/**
 * optional uint32 account_id = 1;
 * @return {number}
 */
proto.reportpb.BalanceSummaryReport.prototype.getAccountId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.BalanceSummaryReport} returns this
 */
proto.reportpb.BalanceSummaryReport.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string correspondent = 2;
 * @return {string}
 */
proto.reportpb.BalanceSummaryReport.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.BalanceSummaryReport} returns this
 */
proto.reportpb.BalanceSummaryReport.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string account_no = 3;
 * @return {string}
 */
proto.reportpb.BalanceSummaryReport.prototype.getAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.BalanceSummaryReport} returns this
 */
proto.reportpb.BalanceSummaryReport.prototype.setAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string sub_account_no = 4;
 * @return {string}
 */
proto.reportpb.BalanceSummaryReport.prototype.getSubAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.BalanceSummaryReport} returns this
 */
proto.reportpb.BalanceSummaryReport.prototype.setSubAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string account_name = 5;
 * @return {string}
 */
proto.reportpb.BalanceSummaryReport.prototype.getAccountName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.BalanceSummaryReport} returns this
 */
proto.reportpb.BalanceSummaryReport.prototype.setAccountName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string master_account_no = 6;
 * @return {string}
 */
proto.reportpb.BalanceSummaryReport.prototype.getMasterAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.BalanceSummaryReport} returns this
 */
proto.reportpb.BalanceSummaryReport.prototype.setMasterAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * repeated AccountBalance account_balances = 7;
 * @return {!Array<!proto.reportpb.AccountBalance>}
 */
proto.reportpb.BalanceSummaryReport.prototype.getAccountBalancesList = function() {
  return /** @type{!Array<!proto.reportpb.AccountBalance>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.reportpb.AccountBalance, 7));
};


/**
 * @param {!Array<!proto.reportpb.AccountBalance>} value
 * @return {!proto.reportpb.BalanceSummaryReport} returns this
*/
proto.reportpb.BalanceSummaryReport.prototype.setAccountBalancesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.reportpb.AccountBalance=} opt_value
 * @param {number=} opt_index
 * @return {!proto.reportpb.AccountBalance}
 */
proto.reportpb.BalanceSummaryReport.prototype.addAccountBalances = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.reportpb.AccountBalance, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.reportpb.BalanceSummaryReport} returns this
 */
proto.reportpb.BalanceSummaryReport.prototype.clearAccountBalancesList = function() {
  return this.setAccountBalancesList([]);
};


/**
 * optional string broker = 8;
 * @return {string}
 */
proto.reportpb.BalanceSummaryReport.prototype.getBroker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.BalanceSummaryReport} returns this
 */
proto.reportpb.BalanceSummaryReport.prototype.setBroker = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string type = 9;
 * @return {string}
 */
proto.reportpb.BalanceSummaryReport.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.BalanceSummaryReport} returns this
 */
proto.reportpb.BalanceSummaryReport.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string date_type = 10;
 * @return {string}
 */
proto.reportpb.BalanceSummaryReport.prototype.getDateType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.BalanceSummaryReport} returns this
 */
proto.reportpb.BalanceSummaryReport.prototype.setDateType = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional google.type.Date date = 11;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.BalanceSummaryReport.prototype.getDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 11));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.BalanceSummaryReport} returns this
*/
proto.reportpb.BalanceSummaryReport.prototype.setDate = function(value) {
  return jspb.Message.setWrapperField(this, 11, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.BalanceSummaryReport} returns this
 */
proto.reportpb.BalanceSummaryReport.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.BalanceSummaryReport.prototype.hasDate = function() {
  return jspb.Message.getField(this, 11) != null;
};


/**
 * optional string cash_balance = 12;
 * @return {string}
 */
proto.reportpb.BalanceSummaryReport.prototype.getCashBalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.BalanceSummaryReport} returns this
 */
proto.reportpb.BalanceSummaryReport.prototype.setCashBalance = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string short_market_value = 13;
 * @return {string}
 */
proto.reportpb.BalanceSummaryReport.prototype.getShortMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.BalanceSummaryReport} returns this
 */
proto.reportpb.BalanceSummaryReport.prototype.setShortMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string long_market_value = 14;
 * @return {string}
 */
proto.reportpb.BalanceSummaryReport.prototype.getLongMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.BalanceSummaryReport} returns this
 */
proto.reportpb.BalanceSummaryReport.prototype.setLongMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string equity = 15;
 * @return {string}
 */
proto.reportpb.BalanceSummaryReport.prototype.getEquity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.BalanceSummaryReport} returns this
 */
proto.reportpb.BalanceSummaryReport.prototype.setEquity = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string adjusted_balance = 16;
 * @return {string}
 */
proto.reportpb.BalanceSummaryReport.prototype.getAdjustedBalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.BalanceSummaryReport} returns this
 */
proto.reportpb.BalanceSummaryReport.prototype.setAdjustedBalance = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional uint32 balance_summary_report_index = 17;
 * @return {number}
 */
proto.reportpb.BalanceSummaryReport.prototype.getBalanceSummaryReportIndex = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.BalanceSummaryReport} returns this
 */
proto.reportpb.BalanceSummaryReport.prototype.setBalanceSummaryReportIndex = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ListBalanceSummary.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ListBalanceSummary.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ListBalanceSummary} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListBalanceSummary.toObject = function(includeInstance, msg) {
  var f, obj = {
    totalRows: jspb.Message.getFieldWithDefault(msg, 1, 0),
    cashBalance: jspb.Message.getFieldWithDefault(msg, 2, ""),
    shortMarketValue: jspb.Message.getFieldWithDefault(msg, 3, ""),
    longMarketValue: jspb.Message.getFieldWithDefault(msg, 4, ""),
    equity: jspb.Message.getFieldWithDefault(msg, 5, ""),
    adjustedBalance: jspb.Message.getFieldWithDefault(msg, 6, ""),
    sdCashBalance: jspb.Message.getFieldWithDefault(msg, 7, ""),
    sdShortMarketValue: jspb.Message.getFieldWithDefault(msg, 8, ""),
    sdLongMarketValue: jspb.Message.getFieldWithDefault(msg, 9, ""),
    sdEquity: jspb.Message.getFieldWithDefault(msg, 10, ""),
    sdAdjustedBalance: jspb.Message.getFieldWithDefault(msg, 11, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListBalanceSummary}
 */
proto.reportpb.ListBalanceSummary.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListBalanceSummary;
  return proto.reportpb.ListBalanceSummary.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListBalanceSummary} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListBalanceSummary}
 */
proto.reportpb.ListBalanceSummary.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTotalRows(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCashBalance(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setShortMarketValue(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setLongMarketValue(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setEquity(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAdjustedBalance(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setSdCashBalance(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setSdShortMarketValue(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setSdLongMarketValue(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setSdEquity(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setSdAdjustedBalance(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListBalanceSummary.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListBalanceSummary.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListBalanceSummary} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListBalanceSummary.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotalRows();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getCashBalance();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getShortMarketValue();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getLongMarketValue();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getEquity();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getAdjustedBalance();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getSdCashBalance();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getSdShortMarketValue();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSdLongMarketValue();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getSdEquity();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getSdAdjustedBalance();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
};


/**
 * optional uint32 total_rows = 1;
 * @return {number}
 */
proto.reportpb.ListBalanceSummary.prototype.getTotalRows = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.reportpb.ListBalanceSummary} returns this
 */
proto.reportpb.ListBalanceSummary.prototype.setTotalRows = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string cash_balance = 2;
 * @return {string}
 */
proto.reportpb.ListBalanceSummary.prototype.getCashBalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListBalanceSummary} returns this
 */
proto.reportpb.ListBalanceSummary.prototype.setCashBalance = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string short_market_value = 3;
 * @return {string}
 */
proto.reportpb.ListBalanceSummary.prototype.getShortMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListBalanceSummary} returns this
 */
proto.reportpb.ListBalanceSummary.prototype.setShortMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string long_market_value = 4;
 * @return {string}
 */
proto.reportpb.ListBalanceSummary.prototype.getLongMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListBalanceSummary} returns this
 */
proto.reportpb.ListBalanceSummary.prototype.setLongMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string equity = 5;
 * @return {string}
 */
proto.reportpb.ListBalanceSummary.prototype.getEquity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListBalanceSummary} returns this
 */
proto.reportpb.ListBalanceSummary.prototype.setEquity = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string adjusted_balance = 6;
 * @return {string}
 */
proto.reportpb.ListBalanceSummary.prototype.getAdjustedBalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListBalanceSummary} returns this
 */
proto.reportpb.ListBalanceSummary.prototype.setAdjustedBalance = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string sd_cash_balance = 7;
 * @return {string}
 */
proto.reportpb.ListBalanceSummary.prototype.getSdCashBalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListBalanceSummary} returns this
 */
proto.reportpb.ListBalanceSummary.prototype.setSdCashBalance = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string sd_short_market_value = 8;
 * @return {string}
 */
proto.reportpb.ListBalanceSummary.prototype.getSdShortMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListBalanceSummary} returns this
 */
proto.reportpb.ListBalanceSummary.prototype.setSdShortMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string sd_long_market_value = 9;
 * @return {string}
 */
proto.reportpb.ListBalanceSummary.prototype.getSdLongMarketValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListBalanceSummary} returns this
 */
proto.reportpb.ListBalanceSummary.prototype.setSdLongMarketValue = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string sd_equity = 10;
 * @return {string}
 */
proto.reportpb.ListBalanceSummary.prototype.getSdEquity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListBalanceSummary} returns this
 */
proto.reportpb.ListBalanceSummary.prototype.setSdEquity = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string sd_adjusted_balance = 11;
 * @return {string}
 */
proto.reportpb.ListBalanceSummary.prototype.getSdAdjustedBalance = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListBalanceSummary} returns this
 */
proto.reportpb.ListBalanceSummary.prototype.setSdAdjustedBalance = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ListReportBalanceRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ListReportBalanceRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ListReportBalanceRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListReportBalanceRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    correspondent: jspb.Message.getFieldWithDefault(msg, 1, ""),
    accountNo: jspb.Message.getFieldWithDefault(msg, 2, ""),
    subAccountNo: jspb.Message.getFieldWithDefault(msg, 3, ""),
    accountName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    masterAccountNo: jspb.Message.getFieldWithDefault(msg, 5, ""),
    branch: jspb.Message.getFieldWithDefault(msg, 6, ""),
    rep: jspb.Message.getFieldWithDefault(msg, 7, ""),
    broker: jspb.Message.getFieldWithDefault(msg, 8, ""),
    type: jspb.Message.getFieldWithDefault(msg, 9, ""),
    date: (f = msg.getDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    dateType: jspb.Message.getFieldWithDefault(msg, 11, ""),
    pagination: (f = msg.getPagination()) && proto_utilspb_pagination_pb.Pagination.toObject(includeInstance, f),
    mode: jspb.Message.getFieldWithDefault(msg, 13, ""),
    hideZero: jspb.Message.getBooleanFieldWithDefault(msg, 14, false),
    fromDate: (f = msg.getFromDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    toDate: (f = msg.getToDate()) && google_type_date_pb.Date.toObject(includeInstance, f),
    debitBalance: jspb.Message.getBooleanFieldWithDefault(msg, 17, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListReportBalanceRequest}
 */
proto.reportpb.ListReportBalanceRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListReportBalanceRequest;
  return proto.reportpb.ListReportBalanceRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListReportBalanceRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListReportBalanceRequest}
 */
proto.reportpb.ListReportBalanceRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setCorrespondent(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountNo(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubAccountNo(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMasterAccountNo(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setBranch(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setRep(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setBroker(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 10:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setDate(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setDateType(value);
      break;
    case 12:
      var value = new proto_utilspb_pagination_pb.Pagination;
      reader.readMessage(value,proto_utilspb_pagination_pb.Pagination.deserializeBinaryFromReader);
      msg.setPagination(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setMode(value);
      break;
    case 14:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setHideZero(value);
      break;
    case 15:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setFromDate(value);
      break;
    case 16:
      var value = new google_type_date_pb.Date;
      reader.readMessage(value,google_type_date_pb.Date.deserializeBinaryFromReader);
      msg.setToDate(value);
      break;
    case 17:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setDebitBalance(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListReportBalanceRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListReportBalanceRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListReportBalanceRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListReportBalanceRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCorrespondent();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountNo();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSubAccountNo();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAccountName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMasterAccountNo();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getBranch();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getRep();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getBroker();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getDate();
  if (f != null) {
    writer.writeMessage(
      10,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getDateType();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getPagination();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto_utilspb_pagination_pb.Pagination.serializeBinaryToWriter
    );
  }
  f = message.getMode();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getHideZero();
  if (f) {
    writer.writeBool(
      14,
      f
    );
  }
  f = message.getFromDate();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getToDate();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      google_type_date_pb.Date.serializeBinaryToWriter
    );
  }
  f = message.getDebitBalance();
  if (f) {
    writer.writeBool(
      17,
      f
    );
  }
};


/**
 * optional string correspondent = 1;
 * @return {string}
 */
proto.reportpb.ListReportBalanceRequest.prototype.getCorrespondent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListReportBalanceRequest} returns this
 */
proto.reportpb.ListReportBalanceRequest.prototype.setCorrespondent = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_no = 2;
 * @return {string}
 */
proto.reportpb.ListReportBalanceRequest.prototype.getAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListReportBalanceRequest} returns this
 */
proto.reportpb.ListReportBalanceRequest.prototype.setAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string sub_account_no = 3;
 * @return {string}
 */
proto.reportpb.ListReportBalanceRequest.prototype.getSubAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListReportBalanceRequest} returns this
 */
proto.reportpb.ListReportBalanceRequest.prototype.setSubAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string account_name = 4;
 * @return {string}
 */
proto.reportpb.ListReportBalanceRequest.prototype.getAccountName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListReportBalanceRequest} returns this
 */
proto.reportpb.ListReportBalanceRequest.prototype.setAccountName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string master_account_no = 5;
 * @return {string}
 */
proto.reportpb.ListReportBalanceRequest.prototype.getMasterAccountNo = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListReportBalanceRequest} returns this
 */
proto.reportpb.ListReportBalanceRequest.prototype.setMasterAccountNo = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string branch = 6;
 * @return {string}
 */
proto.reportpb.ListReportBalanceRequest.prototype.getBranch = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListReportBalanceRequest} returns this
 */
proto.reportpb.ListReportBalanceRequest.prototype.setBranch = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string rep = 7;
 * @return {string}
 */
proto.reportpb.ListReportBalanceRequest.prototype.getRep = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListReportBalanceRequest} returns this
 */
proto.reportpb.ListReportBalanceRequest.prototype.setRep = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string broker = 8;
 * @return {string}
 */
proto.reportpb.ListReportBalanceRequest.prototype.getBroker = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListReportBalanceRequest} returns this
 */
proto.reportpb.ListReportBalanceRequest.prototype.setBroker = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string type = 9;
 * @return {string}
 */
proto.reportpb.ListReportBalanceRequest.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListReportBalanceRequest} returns this
 */
proto.reportpb.ListReportBalanceRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional google.type.Date date = 10;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ListReportBalanceRequest.prototype.getDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 10));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ListReportBalanceRequest} returns this
*/
proto.reportpb.ListReportBalanceRequest.prototype.setDate = function(value) {
  return jspb.Message.setWrapperField(this, 10, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListReportBalanceRequest} returns this
 */
proto.reportpb.ListReportBalanceRequest.prototype.clearDate = function() {
  return this.setDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListReportBalanceRequest.prototype.hasDate = function() {
  return jspb.Message.getField(this, 10) != null;
};


/**
 * optional string date_type = 11;
 * @return {string}
 */
proto.reportpb.ListReportBalanceRequest.prototype.getDateType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListReportBalanceRequest} returns this
 */
proto.reportpb.ListReportBalanceRequest.prototype.setDateType = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional utilspb.Pagination pagination = 12;
 * @return {?proto.utilspb.Pagination}
 */
proto.reportpb.ListReportBalanceRequest.prototype.getPagination = function() {
  return /** @type{?proto.utilspb.Pagination} */ (
    jspb.Message.getWrapperField(this, proto_utilspb_pagination_pb.Pagination, 12));
};


/**
 * @param {?proto.utilspb.Pagination|undefined} value
 * @return {!proto.reportpb.ListReportBalanceRequest} returns this
*/
proto.reportpb.ListReportBalanceRequest.prototype.setPagination = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListReportBalanceRequest} returns this
 */
proto.reportpb.ListReportBalanceRequest.prototype.clearPagination = function() {
  return this.setPagination(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListReportBalanceRequest.prototype.hasPagination = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional string mode = 13;
 * @return {string}
 */
proto.reportpb.ListReportBalanceRequest.prototype.getMode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.reportpb.ListReportBalanceRequest} returns this
 */
proto.reportpb.ListReportBalanceRequest.prototype.setMode = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional bool hide_zero = 14;
 * @return {boolean}
 */
proto.reportpb.ListReportBalanceRequest.prototype.getHideZero = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 14, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ListReportBalanceRequest} returns this
 */
proto.reportpb.ListReportBalanceRequest.prototype.setHideZero = function(value) {
  return jspb.Message.setProto3BooleanField(this, 14, value);
};


/**
 * optional google.type.Date from_date = 15;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ListReportBalanceRequest.prototype.getFromDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 15));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ListReportBalanceRequest} returns this
*/
proto.reportpb.ListReportBalanceRequest.prototype.setFromDate = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListReportBalanceRequest} returns this
 */
proto.reportpb.ListReportBalanceRequest.prototype.clearFromDate = function() {
  return this.setFromDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListReportBalanceRequest.prototype.hasFromDate = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional google.type.Date to_date = 16;
 * @return {?proto.google.type.Date}
 */
proto.reportpb.ListReportBalanceRequest.prototype.getToDate = function() {
  return /** @type{?proto.google.type.Date} */ (
    jspb.Message.getWrapperField(this, google_type_date_pb.Date, 16));
};


/**
 * @param {?proto.google.type.Date|undefined} value
 * @return {!proto.reportpb.ListReportBalanceRequest} returns this
*/
proto.reportpb.ListReportBalanceRequest.prototype.setToDate = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListReportBalanceRequest} returns this
 */
proto.reportpb.ListReportBalanceRequest.prototype.clearToDate = function() {
  return this.setToDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListReportBalanceRequest.prototype.hasToDate = function() {
  return jspb.Message.getField(this, 16) != null;
};


/**
 * optional bool debit_balance = 17;
 * @return {boolean}
 */
proto.reportpb.ListReportBalanceRequest.prototype.getDebitBalance = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 17, false));
};


/**
 * @param {boolean} value
 * @return {!proto.reportpb.ListReportBalanceRequest} returns this
 */
proto.reportpb.ListReportBalanceRequest.prototype.setDebitBalance = function(value) {
  return jspb.Message.setProto3BooleanField(this, 17, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.reportpb.ListBalanceSummaryReportResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.reportpb.ListBalanceSummaryReportResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.reportpb.ListBalanceSummaryReportResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.reportpb.ListBalanceSummaryReportResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListBalanceSummaryReportResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    balanceSummaryReportsList: jspb.Message.toObjectList(msg.getBalanceSummaryReportsList(),
    proto.reportpb.BalanceSummaryReport.toObject, includeInstance),
    summary: (f = msg.getSummary()) && proto.reportpb.ListBalanceSummary.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.reportpb.ListBalanceSummaryReportResponse}
 */
proto.reportpb.ListBalanceSummaryReportResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.reportpb.ListBalanceSummaryReportResponse;
  return proto.reportpb.ListBalanceSummaryReportResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.reportpb.ListBalanceSummaryReportResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.reportpb.ListBalanceSummaryReportResponse}
 */
proto.reportpb.ListBalanceSummaryReportResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.reportpb.BalanceSummaryReport;
      reader.readMessage(value,proto.reportpb.BalanceSummaryReport.deserializeBinaryFromReader);
      msg.addBalanceSummaryReports(value);
      break;
    case 2:
      var value = new proto.reportpb.ListBalanceSummary;
      reader.readMessage(value,proto.reportpb.ListBalanceSummary.deserializeBinaryFromReader);
      msg.setSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.reportpb.ListBalanceSummaryReportResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.reportpb.ListBalanceSummaryReportResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.reportpb.ListBalanceSummaryReportResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.reportpb.ListBalanceSummaryReportResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getBalanceSummaryReportsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.reportpb.BalanceSummaryReport.serializeBinaryToWriter
    );
  }
  f = message.getSummary();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.reportpb.ListBalanceSummary.serializeBinaryToWriter
    );
  }
};


/**
 * repeated BalanceSummaryReport balance_summary_reports = 1;
 * @return {!Array<!proto.reportpb.BalanceSummaryReport>}
 */
proto.reportpb.ListBalanceSummaryReportResponse.prototype.getBalanceSummaryReportsList = function() {
  return /** @type{!Array<!proto.reportpb.BalanceSummaryReport>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.reportpb.BalanceSummaryReport, 1));
};


/**
 * @param {!Array<!proto.reportpb.BalanceSummaryReport>} value
 * @return {!proto.reportpb.ListBalanceSummaryReportResponse} returns this
*/
proto.reportpb.ListBalanceSummaryReportResponse.prototype.setBalanceSummaryReportsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.reportpb.BalanceSummaryReport=} opt_value
 * @param {number=} opt_index
 * @return {!proto.reportpb.BalanceSummaryReport}
 */
proto.reportpb.ListBalanceSummaryReportResponse.prototype.addBalanceSummaryReports = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.reportpb.BalanceSummaryReport, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.reportpb.ListBalanceSummaryReportResponse} returns this
 */
proto.reportpb.ListBalanceSummaryReportResponse.prototype.clearBalanceSummaryReportsList = function() {
  return this.setBalanceSummaryReportsList([]);
};


/**
 * optional ListBalanceSummary summary = 2;
 * @return {?proto.reportpb.ListBalanceSummary}
 */
proto.reportpb.ListBalanceSummaryReportResponse.prototype.getSummary = function() {
  return /** @type{?proto.reportpb.ListBalanceSummary} */ (
    jspb.Message.getWrapperField(this, proto.reportpb.ListBalanceSummary, 2));
};


/**
 * @param {?proto.reportpb.ListBalanceSummary|undefined} value
 * @return {!proto.reportpb.ListBalanceSummaryReportResponse} returns this
*/
proto.reportpb.ListBalanceSummaryReportResponse.prototype.setSummary = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.reportpb.ListBalanceSummaryReportResponse} returns this
 */
proto.reportpb.ListBalanceSummaryReportResponse.prototype.clearSummary = function() {
  return this.setSummary(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.reportpb.ListBalanceSummaryReportResponse.prototype.hasSummary = function() {
  return jspb.Message.getField(this, 2) != null;
};


goog.object.extend(exports, proto.reportpb);
